var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserWarningStatus = function SvgUserWarningStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.757 14.312 10.574 1.87A1.823 1.823 0 0 0 9 .96c-.647 0-1.25.35-1.573.91L.243 14.31a1.822 1.822 0 0 0 0 1.818c.323.56.926.908 1.573.908h14.368c.647 0 1.25-.348 1.573-.908a1.82 1.82 0 0 0 0-1.817ZM9 14.991a1.126 1.126 0 1 1 0-2.251 1.126 1.126 0 0 1 0 2.251Zm.693-3.6a.693.693 0 0 1-1.386 0l-.432-5.089a1.126 1.126 0 0 1 2.25 0l-.432 5.088Z",
    fill: "#DF001A"
  })));
};
export default SvgUserWarningStatus;